import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import Slider from "react-slick";

import vw from 'styles/utils';

function Slick(props) {
  const { icon, title, children } = props;
  const settings = {
    dots: true,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  }

  return (
    <Root>
      <Row>
        <Icon src={icon}/>
        <Title>{title}</Title>
      </Row>
      <Slider {...settings}>
        {children}
      </Slider>
    </Root>
  )
}

Slick.propTypes = {
  icon: PropTypes.any, 
  title: PropTypes.string, 
  children: PropTypes.any
}

const Root = styled.div`
  .slick-arrow {
    display: none !important;
  }
`;

const Row = styled.div`
  display: flex;
  align-items: center;

  ${vw('margin-bottom', 8, 15)}
`;

const Icon = styled.img`
  width: auto;
  height: auto;

  ${vw('max-width', 10, 15)}
  ${vw('max-height', 10, 15)}
  ${vw('margin-right', 6, 10)}
`;

const Title = styled.h5`
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 500;

  ${vw('font-size', 12, 18)}
  ${vw('line-height', 20, 28)}
`;

export default Slick
